import { render, staticRenderFns } from "./Gebreken.vue?vue&type=template&id=5b640328"
import script from "./Gebreken.vue?vue&type=script&lang=js"
export * from "./Gebreken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports